import React from 'react';

const About = () => {
    return (
        <div className="py-4 m-4 bg-light">
            <h1 className="text-center text-danger">ABOUT CoxATour website</h1>
You are here
<p>Home  Website information  
The Tourism New Zealand website newzealand.com is the official tourism website for New Zealand. It features information that is relevant to travellers who are thinking about and actively planning a visit to New Zealand.

Through this site, potential visitors will be able to learn about the diversity of what New Zealand has to offer and how to make their visit a fantastic experience.

newzealand.com has an open content model and Tourism New Zealand encourages tourism businesses, previous travellers to New Zealand, and Kiwis to contribute content to the website to help future travellers plan their trip.

Contributing an article
Do you have a great New Zealand travel story to tell? Is there a must-do experience you recommend future travellers see or do? Have you got practical travel advice you want to share? If so, please create an article so that others can benefit from your knowledge and experience. Simply sign-up to create your account.

All article content submitted to the site for publication is reviewed by Tourism New Zealand for relevance, completeness and web hygiene factors (e.g. use of images). However, content contributed to the website by in large is published the way the author intended and all content is clearly attributed to the author.</p>
<p>
When an author is creating an article for newzealand.com they must ‘tag’ the article and can include up to five keywords or topics. The tags determine where on the website the article will surface (usually in multiple places) and help website users find content to meet their specific information needs. For example, an article about a recommended mountain biking experience in Queenstown could be tagged, Queenstown, mountain biking, adventure, and Summer. The same article could be found by a consumer if they are interested in any of these places, activities or topics..</p>



<p>Only the author can edit their article
Any newzealand.com user can comment on an article. Article authors should regularly review the comments against their article and respond positively.
Any newzealand.com user can share an article via social media.
Tourism business listings
The website features a database of tourism industry operators in New Zealand and those selling New Zealand offshore, each with an individual web page that details the attractions and experiences they offer. Once you have decided what you want to do and where you want to travel, you can make direct contact with individual tourism operators and where applicable make a booking through them.</p>



<ul>
    <li>Accommodation</li>
    <li>Activities & tours</li>
    <li>Online booking services</li>
    <li>Transport</li>
    <li>Travel agents and airlines</li>
    <li>Visitor information services</li>
    </ul>
    <p>If you are a tourism operator and would like to list your business on this site, please go to www.register.newzealand.com and complete the online forms. It’s free to create a listing and all information is checked and validated by our team.</p>


<p>You can search the entire site using the search box which appears in the top right corner of all pages. newzealand.com’s search tool is powered by SwiftType and it crawls all pages, business listings and other site content to find the best matches to the words or phrase you have chosen.

Terms and Conditions
See Tourism New Zealand's Website Terms of Use for the www.newzealand.com website.</p>

<p>Tourism New Zealand is the organisation responsible for marketing New Zealand to the world as a tourist destination. Through the 100% Pure New Zealand campaign we take New Zealand's story to consumers, the travel trade and the global media, while working with the industry here in New Zealand to ensure we deliver on the promises made through the campaign.</p>
        </div>
    );
};

export default About;